import axios from 'axios'

const CSRF_COOKIE_NAME = 'csrftoken'
const CSRF_HEADER_NAME = 'X-CSRFToken'

const session = axios.create({
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: CSRF_HEADER_NAME,
})

if (process.env.NODE_ENV !== 'production') {
  session.interceptors.request.use(
    function(config) {
      // Do something before request is sent
      return config
    },
    function(error) {
      // Do something with request error
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data)
        console.log(error.response.status)
        console.log(error.response.headers)
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
      }
      return Promise.reject(error)
    }
  )
}

if (!process.env.VUE_APP_TEST) {
  const store = require('../state/store.js')

  session.interceptors.response.use(
    function(response) {
      return response
    },
    function(error) {
      if (
        error.response.status === 401 &&
        !store.default.state.users.userSessionExpired.userSessionExpired
      ) {
        // detail invalid token.
        store.default.commit('users/SESSION_EXPIRE', null, { root: true })
        // // Just in case an update was ongoing
        store.default.commit('users/UPDATE_CLEAR', null, { root: true })
      }

      return Promise.reject(error)
    }
  )
}
export default session
